import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoneyInputComponent } from './money-input.component';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { NumericTextBoxModule } from '@progress/kendo-angular-inputs';

@NgModule({
  declarations: [
    MoneyInputComponent
  ],
  imports: [
    CommonModule,
    TooltipModule,
    NumericTextBoxModule
  ],
  exports: [
    MoneyInputComponent
  ]
})
export class MondeyInputModule { }
